<template>
  <v-card class="card-pad card mr-0" color="#ffff" max-width="680">
    <div class="content-card">
      <v-img
        src="/img/icons/fix-icon-1.svg"
        alt="Fix logo"
        contain
        max-height="80"
      ></v-img>

      <div class="title-card">
        <span> {{ title }} </span>
      </div>

      <div class="description-screen mt-8">
        <div class="title">
          <span>{{ titlePage }}</span>
        </div>
        <div class="description">
          <span>{{ descriptionPage }}</span>
        </div>
      </div>

      <div class="slot-card">
        <slot />
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    title: { type: String, required: true, default: 'Insira a prop title' },
    titlePage: { type: String, default: '' },
    descriptionPage: { type: String, default: '' },
  },
}
</script>

<style lang="scss" scoped>
.card {
  padding: 80px 15px;
  border: 1px solid;
  width: 100%;
  z-index: 1 !important;
  .content-card {
    max-width: 80%;
    margin: 0 auto;

    .logo-card {
      height: 100px;
      width: 140px;
      margin: 0 auto;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        image-rendering: pixelated;
      }

      @media (max-width: 700px) {
        height: 60px;
        width: 100px;
      }
    }

    .title-card {
      margin: 1rem 0;
      width: 100%;
      span {
        font-weight: 700;
        font-size: 36px;
        line-height: 49px;
        color: $black-1;
      }
    }

    .description-screen {
      margin: 1rem 0;
      display: none;
      .title {
        color: $black-1;
        span {
          font-weight: 800;
          font-size: 18px;
          line-height: 25px;
        }
      }
      .description {
        color: $black-1;
        span {
          font-weight: 400;
          font-size: 12px;
          line-height: 16px;
        }
      }
    }

    @media (max-width: $mobile-1) {
      .title-card {
        display: none;
      }
      .description-screen {
        display: block;
      }
    }
  }
}
</style>
